// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__RvmYL","arrowIcon":"DateRangeController_arrowIcon__10Kb8"};